import React, { ReactNode } from 'react';

import {
  ConfirmationDialogContext,
  ConfirmationDialogInputValidationResult,
} from '../ConfirmationDialog/ConfirmationDialog';
export interface GetConfirmationProps {
  content: ReactNode | string;
  headerText: string;
  confirmButtonText: string;
  cancelButtonText: string;
  showCloseButton: boolean;
  prompt?: boolean;
  validate?(input: string | undefined): ConfirmationDialogInputValidationResult;
}

export const useConfirmationDialog = () => {
  const { openDialog } = React.useContext(ConfirmationDialogContext);

  const getConfirmation = (
    props: GetConfirmationProps,
  ): Promise<boolean | string> =>
    new Promise(response => {
      openDialog?.({ actionCallback: response, ...props });
    });

  return { getConfirmation };
};
